import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import Image from 'next/image';
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from '@/app/cc/_component/ui/section/AnsimSolution/AnsimSolution.module.scss';
interface SolutionCardProps {
  readonly title: string;
  readonly description: string;
  readonly icon: {
    readonly src: string;
    readonly alt: string;
    readonly backgroundColor: string;
  };
}
export default function SolutionCard(t0) {
  const $ = _c(21);
  const {
    title,
    description,
    icon
  } = t0;
  const t1 = styles[icon.backgroundColor];
  let t2;
  if ($[0] !== t1) {
    t2 = clsx(styles.icon, t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== icon.alt || $[3] !== icon.src) {
    t3 = <Image src={icon.src} alt={icon.alt} width={36} height={36} />;
    $[2] = icon.alt;
    $[3] = icon.src;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== title) {
    t5 = <Text as="p" category="heading" variant="sb2" color="var(--color-gray-0)">{title}</Text>;
    $[8] = title;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Image src="/cc/image/icon_dot.svg" alt="dot_icon" width={5} height={5} />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5) {
    t7 = <div className={styles.title}>{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== description) {
    t8 = <Text as="p" category="body" variant="r2" color="var(--color-gray-0)">{description}</Text>;
    $[13] = description;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <div>{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t4 || $[19] !== t9) {
    t10 = <div className={styles.solutionCard}>{t4}{t9}</div>;
    $[18] = t4;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}